export default __webpack_public_path__ + "static/media/labor.7287fe2e.svg";